module.exports = __webpack_public_path__ + "static/media/whiteCrossIcon.c88c2fd3.svg";